export default __webpack_public_path__ + "static/media/ASL.6487dfc5.png";